// When an invisible reCAPTCHA v3 check doesn't pass, the controller re-renders
// the form with an explicit v2 checkbox (#hv-captcha-fallback in
// shared/_recaptcha.html.erb). That checkbox wasn't on screen when the user
// first submitted, so scroll it into view and briefly pulse it.
//
// Ported from the village app. Idempotent via a per-element data flag so the
// pulse doesn't restart when both turbolinks:load and DOMContentLoaded fire.
(function() {
    function hvInitCaptchaFallback() {
        var box = document.getElementById('hv-captcha-fallback');
        if (!box) return;
        if (box.dataset.hvPulsed) return;
        box.dataset.hvPulsed = 'true';

        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        box.classList.add('hv-captcha-pulse');
    }

    document.addEventListener('turbolinks:load', hvInitCaptchaFallback);
    document.addEventListener('DOMContentLoaded', hvInitCaptchaFallback);
})();
